// extracted by mini-css-extract-plugin
export default {"wrapper":"PageNotFound_wrapper__iQCRO","content":"PageNotFound_content__+dLIV","buttonWrapper":"PageNotFound_buttonWrapper__5U6-T","button":"PageNotFound_button__lgMyE"};